/**
 * Returns a Date object set to local midnight (00:00:00.000) for today.
 *
 * @example
 * // User is in UTC+3, current time is 2026-05-27T14:00:00+03:00
 * getTodayLocal()  // → 2026-05-27T00:00:00.000+03:00
 */
export const getTodayLocal = (): Date => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
